import React from 'react';
import styled from '@material-ui/styles/styled';
import PanelHeaderButton, {
  PanelHeaderButtonProps,
} from '@vkontakte/vkui/dist/components/PanelHeaderButton/PanelHeaderButton';

export default styled(PanelHeaderButton)({
  cursor: 'pointer',
}) as React.FC<PanelHeaderButtonProps>;
